import { Trampoline } from "@siteimprove/alfa-trampoline";
import * as json from "@siteimprove/alfa-json";
import { Node } from "../node.js";
/**
 * @public
 */
export class Comment extends Node {
    static of(data, externalId, internalId, extraData) {
        return new Comment(data, externalId, internalId, extraData);
    }
    static empty() {
        return new Comment("");
    }
    _data;
    constructor(data, externalId, internalId, extraData) {
        super([], "comment", externalId, internalId, extraData);
        this._data = data;
    }
    get data() {
        return this._data;
    }
    /**
     * @internal
     **/
    _internalPath(options) {
        let path = this.parent(options)
            .map((parent) => parent.path(options))
            .getOr("/");
        path += path === "/" ? "" : "/";
        path += "comment()";
        const index = this.preceding(options).count(Comment.isComment);
        path += `[${index + 1}]`;
        return path;
    }
    toJSON(options) {
        const result = {
            ...super.toJSON(options),
        };
        delete result.children;
        const verbosity = options?.verbosity ?? json.Serializable.Verbosity.Medium;
        if (verbosity < json.Serializable.Verbosity.Medium) {
            return result;
        }
        result.data = this._data;
        return result;
    }
    toString() {
        return `<!--${this._data}-->`;
    }
}
/**
 * @public
 */
(function (Comment) {
    function isComment(value) {
        return value instanceof Comment;
    }
    Comment.isComment = isComment;
    /**
     * @internal
     */
    function fromComment(json) {
        return Trampoline.done(Comment.of(json.data, json.externalId, json.internalId));
    }
    Comment.fromComment = fromComment;
    /**
     * @internal
     */
    function cloneComment(comment) {
        return Trampoline.done(Comment.of(comment.data, comment.externalId, comment.internalId, comment.extraData));
    }
    Comment.cloneComment = cloneComment;
})(Comment || (Comment = {}));
//# sourceMappingURL=comment.js.map